module.exports = __webpack_public_path__ + "static/media/logo.e069cb1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 188
// module chunks = 0